import { getSupabaseConfigError, formatSupabaseError } from '../../supabase';
import { invalidateCache } from '../cache/queryCache';

const GYM_ID_KEY = 'gym-current-id';

let cachedGymId = null;
/** Set from logged-in admin / receptionist — always wins over session storage */
let authBoundGymId = null;

export function getCachedGymId() {
  return authBoundGymId || cachedGymId || sessionStorage.getItem(GYM_ID_KEY);
}

export function resetGymIdCache() {
  cachedGymId = null;
  authBoundGymId = null;
  sessionStorage.removeItem(GYM_ID_KEY);
}

export function setActiveGymId(id) {
  if (!id) {
    const hadGym = Boolean(authBoundGymId || cachedGymId || sessionStorage.getItem(GYM_ID_KEY));
    resetGymIdCache();
    if (hadGym) invalidateCache('gym:');
    return '';
  }

  const previous = authBoundGymId || cachedGymId || sessionStorage.getItem(GYM_ID_KEY);
  authBoundGymId = id;
  rememberGymId(id);

  if (previous !== id) {
    invalidateCache('gym:');
  }

  return id;
}

function rememberGymId(id) {
  cachedGymId = id;
  sessionStorage.setItem(GYM_ID_KEY, id);
  return id;
}

/**
 * Resolve the active gym for data queries.
 * For logged-in staff, use the auth-bound gym synchronously — no network ping every call.
 */
export async function ensureGymId() {
  const configError = getSupabaseConfigError();
  if (configError) throw new Error(configError);

  if (authBoundGymId) {
    return rememberGymId(authBoundGymId);
  }

  const stored = cachedGymId || sessionStorage.getItem(GYM_ID_KEY);
  if (stored) {
    // Soft recovery after HMR / refresh within the same tab session
    return rememberGymId(stored);
  }

  throw new Error(
    'No gym is linked to this account. Sign out and sign in again, or ask the platform owner to link your admin account to a gym.',
  );
}

export function handleDbError(error, fallback = 'Database request failed.') {
  if (!error) return null;
  console.error(error);
  return formatSupabaseError(error, fallback);
}
